// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistantsalesorder_submissionstatus_autosubmitfailed5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-submission to the ERP failed. Please submit manually.`)
};

const en_us2_assistantsalesorder_submissionstatus_autosubmitfailed5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-submission to the ERP failed. Please submit manually.`)
};

const de_de2_assistantsalesorder_submissionstatus_autosubmitfailed5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Übermittlung an das ERP ist fehlgeschlagen. Bitte manuell übermitteln.`)
};

const en_assistantsalesorder_submissionstatus_autosubmitfailed5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-submission to the ERP failed. Please submit manually.`)
};

const de_assistantsalesorder_submissionstatus_autosubmitfailed5 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die automatische Übermittlung an das ERP ist fehlgeschlagen. Bitte manuell übermitteln.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistantsalesorder_submissionstatus_autosubmitfailed5 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistantsalesorder_submissionstatus_autosubmitfailed5(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistantsalesorder_submissionstatus_autosubmitfailed5", locale)
	if (locale === "en-GB") return en_gb2_assistantsalesorder_submissionstatus_autosubmitfailed5(inputs)
	if (locale === "en-US") return en_us2_assistantsalesorder_submissionstatus_autosubmitfailed5(inputs)
	if (locale === "de-DE") return de_de2_assistantsalesorder_submissionstatus_autosubmitfailed5(inputs)
	if (locale === "en") return en_assistantsalesorder_submissionstatus_autosubmitfailed5(inputs)
	return de_assistantsalesorder_submissionstatus_autosubmitfailed5(inputs)
};
export { assistantsalesorder_submissionstatus_autosubmitfailed5 as "assistantSalesOrder.submissionStatus.autoSubmitFailed" }